import api from "../api";

export const sp = (schemaName) => (schemaName ? { client: schemaName } : {});

export { api };
